<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header justify-content-start">
    <div class="modal-title">Frequently Asked Question</div>
  </div>
  <div class="modal-body" [formGroup]="option">

    <div class="position-relative mb-4">
      <label class="form-check-label form-check-label--paybee mb-1">Text block</label>
      <mdb-form-control class="mb-4">     
        <app-quill-custom mdbInput formControlName="question" limit="256"></app-quill-custom>
      </mdb-form-control>
    </div>
    <div class="position-relative mb-4">
      <label class="form-check-label form-check-label--paybee mb-1">Answer</label>
      <mdb-form-control class="mb-4">     
        <app-quill-custom mdbInput formControlName="answer" limit="1024"></app-quill-custom>
      </mdb-form-control>
    </div>

    <div class="divider"></div>
  </div>
  <div class="modal-footer modal-footer--add-guest">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <button type="button" class="btn btn--paybee btn--transparent btn--md mr-3 footer-btn" (click)="close(dialog, false)">Cancel</button>
        <button type="button" class="btn btn--paybee btn--black btn--md footer-btn" (click)="confirm(dialog, option.value)">Confirm</button>
      </div>
    </div>
  </div>
</ng-container>
